import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { IpnDetailsTabContent } from '@/areas/components/IpnDetailsPage/components/IpnDetailsTabController';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/components/ipn/_details/cpns')({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ ipnId: 'required' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const ipnId = Route.useSearch({ select: (search) => search.ipnId });
    return <IpnDetailsTabContent tab={'cpns'} ipnId={ipnId} />;
}
